module.exports = __webpack_public_path__ + "static/media/geomil.b7c1e3db.png";